import React from 'react';
import { Button } from '~/shared/components';
import { ResetButton } from '~/shared/components/Button/ResetButton';
import { Dialog, DialogContent } from '~/shared/components/Dialog';
import Typography from '~/shared/components/Typography/Typography';
import CloseIcon from '~/icons/close.svg';
import { useTranslation } from '~/shared/utils/translation';
import styles from './SuggestedStoreChangeDialog.module.scss';

type Props = {
    isOpen: boolean;
    storeName: string;
    onConfirm: () => void;
    onCancel: () => void;
};

export const SuggestedStoreChangeDialog = ({ isOpen, storeName, onConfirm, onCancel }: Props) => {
    const { translate } = useTranslation();

    const title = translate('checkout.delivery.singleDeliveryPoint.title');
    const message = translate('checkout.delivery.singleDeliveryPoint.message', { storeName });
    const confirmText = translate('checkout.delivery.singleDeliveryPoint.confirm');
    const cancelText = translate('checkout.delivery.singleDeliveryPoint.cancel');
    const closeText = translate('accessibility.closeIconTitle');

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
            <DialogContent preventDismiss>
                <div className={styles.dialogContainer}>
                    <ResetButton
                        className={styles.dialogCloseButton}
                        onClick={onCancel}
                        aria-label={closeText}
                        type="button"
                    >
                        <CloseIcon />
                    </ResetButton>
                    <Typography as="h2" variant="title-XS" className={styles.dialogTitle}>
                        {title}
                    </Typography>
                    <Typography as="p" variant="paragraph-XL" className={styles.dialogMessage}>
                        {message}
                    </Typography>
                    <div className={styles.dialogButtonsContainer}>
                        <Button
                            className={styles.dialogButton}
                            variant="primary"
                            onClick={onConfirm}
                        >
                            <Typography variant="paragraph-M">{confirmText}</Typography>
                        </Button>
                        <ResetButton className={styles.dialogCancelButton} onClick={onCancel}>
                            <Typography variant="paragraph-M">{cancelText}</Typography>
                        </ResetButton>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
